import axios from 'axios'

const baseUrl = 'https://zipcloud.ibsnet.co.jp/api/search'

const normalizeNumHyphen = (s) => {
  if (!s) return s
  let v = s.replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0))
  v = v.replace(/[ー−－]/g, '-')
  return v
}

export async function searchAddress(postalCode) {
  if (!postalCode) {
    return {
      success: false,
      message: '郵便番号を入力してください',
    }
  }
  const normalizedPostalCode = normalizeNumHyphen(postalCode)
  const zipForApi = normalizedPostalCode.replace(/\D/g, '')
  if (zipForApi.length !== 7) {
    return {
      success: false,
      message: '郵便番号が正しくありません',
    }
  }
  try {
    const res = await axios.get(`${baseUrl}?zipcode=${zipForApi}`)
    if (res.data.status === 200) {
      if (res.data.results) {
        const result = res.data.results[0]
        return {
          success: true,
          prefecture: result.address1,
          address: result.address2,
          address2: result.address3,
        }
      } else {
        return {
          success: false,
        }
      }
    } else if (res.data.status === 400) {
      return {
        success: false,
        message: '郵便番号が正しくありません',
      }
    }
    return {
      success: false,
      message: 'サーバーエラーが発生しました。お手数ですが住所を直接入力してください。',
    }
  } catch {
    return {
      success: false,
      message: 'エラーが発生しました。お手数ですが住所を直接入力してください。',
    }
  }
}

export const Prefectures = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
]
